import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { OfferStack } from './components/OfferStack';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
export function App() {
  return <div className="min-h-screen bg-night-900 text-gray-100 font-sans selection:bg-accent-blue/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <MethodSection data-id="element-5" />
      <OfferStack data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <ComparisonSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
    </div>;
}